import React from 'react';
import DialogContent from '@material-ui/core/DialogContent';
import Dialog from '@material-ui/core/Dialog';
import BrandLoader from './BrandLoader';

interface IProps {
  open: boolean;
  onClose?: () => any;
}

// The loader floats over the dimmed page, with no card behind it.
const LoaderDialog = ({ open, onClose = () => undefined }: IProps) => (
  <Dialog
    open={open}
    onClose={onClose}
    disableBackdropClick
    disableEscapeKeyDown
    PaperProps={{ style: { background: 'transparent', boxShadow: 'none' } }}
  >
    <DialogContent style={{ overflow: 'hidden' }}>
      <BrandLoader size={96} />
    </DialogContent>
  </Dialog>
);

export default LoaderDialog;
